import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ListFiltersState } from '../reducers/base-list-filters.reducer';
import { ListFilterParams } from '../actions/base-list-filters.actions';

const getListFilters = createFeatureSelector<ListFiltersState>('listFilters');

export const selectListFilterSnapshot = (routeKey: string) =>
  createSelector(getListFilters, (state): ListFilterParams | undefined => state?.snapshots?.[routeKey]);
